import { render, staticRenderFns } from "./EstagiariosMagisterio.vue?vue&type=template&id=74a13c94&scoped=true"
import script from "./EstagiariosMagisterio.vue?vue&type=script&lang=js"
export * from "./EstagiariosMagisterio.vue?vue&type=script&lang=js"
import style0 from "./EstagiariosMagisterio.vue?vue&type=style&index=0&id=74a13c94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a13c94",
  null
  
)

export default component.exports